import React, { PropsWithChildren, Ref } from 'react';

type FormsComboboxMultiSelectListElementType = PropsWithChildren<{
  ref?: Ref<any>;
  onAnimationEnd?: (event: React.AnimationEvent<HTMLLIElement>) => void;
}>;

export function FormsComboboxMultiSelectListElement({
  ref,
  onAnimationEnd,
  children,
}: FormsComboboxMultiSelectListElementType) {
  return (
    <li ref={ref} onAnimationEnd={onAnimationEnd} className="forms-combobox-multiselect__list-item">
      {children}
    </li>
  );
}
